import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { LoginProviderType } from './User.js';
export class OpenIDClientConfiguration extends AutoEncoder {
}
__decorate([
    field({ decoder: StringDecoder })
], OpenIDClientConfiguration.prototype, "issuer", void 0);
__decorate([
    field({ decoder: StringDecoder })
], OpenIDClientConfiguration.prototype, "clientId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], OpenIDClientConfiguration.prototype, "clientSecret", void 0);
export class StartOpenIDFlowStruct extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.webshopId = null;
        /**
         * sso (= use one configured in organization), google, apple, ... (for now only sso supported)
         */
        this.provider = LoginProviderType.SSO;
        /**
         * sso (= use one configured in organization), google, apple, ... (for now only sso supported)
         */
        this.prompt = null;
        this.redirectUri = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], StartOpenIDFlowStruct.prototype, "webshopId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], StartOpenIDFlowStruct.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], StartOpenIDFlowStruct.prototype, "spaState", void 0);
__decorate([
    field({ decoder: new EnumDecoder(LoginProviderType) })
], StartOpenIDFlowStruct.prototype, "provider", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], StartOpenIDFlowStruct.prototype, "prompt", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], StartOpenIDFlowStruct.prototype, "redirectUri", void 0);
//# sourceMappingURL=OpenID.js.map